







































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { YKDHeader } from "ykd-components";
import QRCode from "qrcode";

@Component({
  components: {
    YKDHeader
  }
})
export default class Academy extends Vue {
  mounted() {
    const el = document.querySelector(".down .qrcode");
    if (el) {
      const canvas = el.querySelector("canvas");
      const loc = window.location;
      const url = `${loc.protocol}//o.youkeda.com/appdown`;
      QRCode.toCanvas(canvas, url, { margin: 1 });
    }
  }
}
